import { ServerEnvUrl } from './server-env-config';
 
export class EnvConfig {

  public static get API_V1_SUFFIX(): string {
    return '/api/v1';
  }

  public static get API_URL(): string {
    return ServerEnvUrl.API_URL;
  }

  public static get APP_URL(): string {
    return ServerEnvUrl.APP_URL;
  }

  public static get SOCKET_URL(): string {
    return ServerEnvUrl.SOCKET_URL;
  }

  public static get WEBAPP_URL(): string {
    return ServerEnvUrl.WEBAPP_URL;
  }

  public static get API_AUTH(): string {
    return '/auth';
  }

  public static get API_TRIAL(): string {
    return '/trial';
  }

  public static get API_CATEGORIES(): string {
    return '/category';
  }

  public static get API_WORKERS(): string {
    return '/worker';
  }

  public static get API_CLIENTS(): string {
    return '/client';
  }

  public static get API_CLIENT_CONTACTS(): string {
    return '/client-contacts';
  }

  public static get API_ROLES(): string {
    return '/role';
  }

  public static get API_TASKS(): string {
    return '/task';
  }

  public static get API_TASKS_COMMENTS(): string {
    return '/task-comments';
  }

  public static get API_TIMETRACK(): string {
    return '/timetrack';
  }

  public static get API_CURRENCIES(): string {
    return '/currency';
  }

  public static get API_COUNTRIES(): string {
    return '/country';
  }

  public static get API_COMPANIES(): string {
    return '/company';
  }

  public static get API_PRODUCTS(): string {
    return '/product';
  }

  public static get API_VENDORS(): string {
    return '/vendor';
  }

  public static get API_FILES(): string {
    return '/files';
  }

  public static get API_APPOINTMENT(): string {
    return '/appointment';
  }

  public static get API_SCHEDULE(): string {
    return '/schedule';
  }

  public static get API_BILLING_DOCUMENTS(): string {
    return '/billing-documents';
  }

  public static get API_CORRECTIVE_INVOICES(): string {
    return '/corrective-invoice';
  }

  public static get API_RECEIPTS(): string {
    return '/receipt';
  }

  public static get API_COUNTERS(): string {
    return '/counters';
  }

  public static get API_QUOTES(): string {
    return '/quote';
  }

  public static get API_SERVICEAGREEMENTS(): string {
    return '/service-agreement';
  }

  public static get API_EXTERNAL(): string {
    return '/external';
  }

  public static get API_FEATURES(): string {
    return '/feature';
  }

  public static get API_SETTINGS(): string {
    return '/setting';
  }

  public static get API_SUBSCRIPTIONS(): string {
    return '/subscription';
  }

  public static get API_COMPANY_SETTINGS(): string {
    return '/company-setting';
  }

  public static get API_LOGGER(): string {
    return '/logger';
  }

  public static get API_DELIVERY_NOTES(): string {
    return '/delivery-notes';
  }

  public static get API_NOTIFICATIONS(): string {
    return '/notification';
  }

  public static get API_ASSISTANTS(): string {
    return '/assistants-api';
  }

  public static get API_AGENTS(): string {
    return '/agents';
  }

  public static get API_TASK_REQUESTS(): string {
    return '/task-request';
  }

  public static get API_PROJECTS(): string {
    return '/project';
  }

  public static get API_DASHBOARD(): string {
    return '/dashboard';
  }

  public static get API_EXPENSES(): string {
    return '/expenses';
  }

  public static get API_EXPENSES_REPORT(): string {
    return '/expenses-report';
  }
}

export function apiURL(endpoint: string): string {
  return EnvConfig.API_URL + EnvConfig.API_V1_SUFFIX + endpoint;
}

export function appURL(target: string): string {
  return ServerEnvUrl.APP_URL + target;
}

export function webappURL(target: string): string {
  return ServerEnvUrl.WEBAPP_URL + '/' + target;
}

export function socketURL(): string {
  return EnvConfig.SOCKET_URL;
}

export function watsappURL(pars?: { text?: string, phone?: string }): string {
  return 'https://api.whatsapp.com/send?'
    + (pars?.text ? 'text=' + pars.text : '') + '&'
    + (pars?.phone ? 'phone=' + pars.phone : '') + '&';
}

